import { BaseApi } from '../apiBase';
import type { AgendasResponse, AgendaResponse, AgendaIndex, Agenda } from '../../types/agenda.types';

export class AgendasApi extends BaseApi {
  constructor(eventSlug: string) {
    super(`/api/portal/events/${eventSlug}/agendas`);
  }

  async getAgendas(): Promise<AgendaIndex[]> {
    return this.get<AgendaIndex[]>('');
  }

  async getAgenda(agendaId: string): Promise<Agenda> {
    return this.get<Agenda>(`/${agendaId}`, {
      include: [
        'days',
        'days.sessions',
        'days.sessions.speakers',
        'days.sessions.attachments',
        'days.sessions.tracks',
        'days.sessions.credit_types',
        'days.sessions.universal_categories',
        'days.sessions.breakout_sessions',
        'days.sessions.survey'
      ].join(',')
    });
  }
}

// Factory function to create API instance
export const createAgendasApi = (eventSlug: string) => new AgendasApi(eventSlug);